import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/pages/landing/Landing';

Vue.use(Router);

const title = ' | Young Forever - mobilny gabinet kosmetyczny';

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      meta: {
        title: `Plasma IQ, Lifting bezinwazyjny ${title}`,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js